<template>
  <div :class="['w3-row', 'definition-wrapper', 'html', definition.id, {'error_validate': mandatoryValidation}]">
    <div :class="['w3-col', 'tiny', {'languageHtml': (isMultiLanguage() && showMultilanguage) || (definition.task && definition.task.length > 0 && editable)}, {'translation': isForCopy()}]">
      <div class="tinymcetmd">
        <div v-if="readOnly" class="htmlReadOnlyWrapper">
          <iframe class="htmlReadOnly" scrolling="no"
            :ref="tinyId"
          />
        </div>
        <div v-else>
          <transition-group v-if="!isSimpleHtml" name="fade">
            <div v-show="editing" class="editing" key="editingZone">
              <transition name="fade" mode="out-in">
                <div>
                  <!-- grapes-js-editor removed: not used in Vue 3 -->
                  <div class="editor-buttons">
                    <button class="save" @click="saveEditor"><span><i class="far fa-save"></i> {{ getLang('saveContentChanges') }}</span></button>
                    <button class="cancel" @click="cancelEditor"><span><i class="sherpa-icon icon-eliminar"></i> {{ getLang('cancelChanges') }}</span></button>
                  </div>
                </div>
              </transition>
            </div>
            <div v-show="!editing" class="preview" key="noEditingZone">
              <transition name="gallery-fade">
                <div class="overImage" v-if="!isHtmlUploaded() && editable">
                  <div class="text">
                    <span class="edit" @click="previewToEdit"><i class="sherpa-icon icon-editar"></i> {{ getLang('edit') }}</span>
                    <!-- <span class="delete" @click="deleteHtml"><i class="sherpa-icon icon-trash"></i> {{ getLang('deleteHtml') }}</span> -->
                  </div>
                </div>
              </transition>
              <iframe class="htmlReadOnly" scrolling="yes"
                :ref="previewId"
              />
              <button class="html2PdfButton" @click="downloadHtml2Pdf()"><i class="sherpa-icon icon-descarga"></i></button>
            </div>
          </transition-group>
          <div v-else class="simple-html">
            <QuillEditor v-model:content="htmlValue" content-type="html" :toolbar="simpleHtmlCustomToolbar" @textChange="simpleHtmlTextChange" :readOnly="!editable"></QuillEditor>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isMultiLanguage() && showMultilanguage" class="w3-rest tiny-rest" :class="['languageSelectorOrTask']">
      <div v-if="editorContent && isMultiLanguage() && showMultilanguage" :class="['languageSelectorHtml', 'languageSelector']">
        <definition-multilanguage v-show="this.object.languageValue && this.object.languageValue.length > 1"
          :definition="definition" :object="object" :languageSelected="languageSelected" :translating="translating" :language="language" :apiparams="apiparams"
          @newLanguageSelected="newLanguageSelected" @copy="copy"
        />
      </div>
    </div>
    <definition-task v-if="definition.task && definition.task.length > 0 && editable"
      class="w3-col" :definition="definition" :object="object" :definitionObject="definitionObject" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :languageSelected="languageSelected" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :callTask="callTask"
      @refreshDefinition="taskValueChanged" @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
    />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import DefinitionMultilanguage from './multilanguage'
import DefinitionTask from './task'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'
import language from '../language'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
// https://github.com/eKoopmans/html2pdf.js
import html2pdf from 'html2pdf.js'

export default {
  name: 'definition-html',
  props: [
    'content',
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'tinyId',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'readOnly',
    'showMultilanguage',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'isHtmlHide',
    'isSimpleHtml',
    'callTask'
  ],
  components: {
    DefinitionReadOnly,
    DefinitionMultilanguage,
    DefinitionTask,
    QuillEditor
  },
  data () {
    return {
      htmlValue: '',
      validation: null,
      initParam: null,
      txt: '',
      translating: false,
      previousLanguageKey: null,
      savingLanguageTemplate: false,
      editorTexts: {
        addIndividualParamsTitle: this.getLang('addIndividualParamsTitle'),
        addProfessionalParamsTitle: this.getLang('addProfessionalParamsTitle'),
        addIndicatorParamsTitle: this.getLang('addIndicatorParamsTitle'),
        addMeetingParamsTitle: this.getLang('addMeetingParamsTitle'),
        addMinutesParamsTitle: this.getLang('addMinutesParamsTitle'),
        addCertificateParamsTitle: this.getLang('addCertificateParamsTitle'),
        selectText: this.getLang('select')
      },
      saveTemplate: null,
      editorContent: null,
      editorContentBckp: null,
      editing: false,
      previewId: 'preview',
      loadingEditor: false,
      simpleHtmlCustomToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ header: 1 }, { header: 2 }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ color: [] }, { background: [] }],
        ['link'],
        [{ direction: 'rtl' }],
        ['clean']
      ]
    }
  },
  methods: {
    // 1.1. Launch validate mandatory event on change
    valueChanged (event) {
      this.setObjectHtmlValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    taskValueChanged (object) {
      if (this.isMultiLanguage()) {
        this.htmlValue = transport.methods.getLanguageValue(object, this.languageSelected.key)
      } else {
        this.htmlValue = object.textValue
      }
      this.setObjectHtmlValue(object, true)
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    validateHtmlFormat () {
      var format = null
      if (this.isMultiLanguage()) {
        format = transport.methods.getLanguage(this.languageSelected.key, this.definition).format
      } else {
        format = this.definition.validation.format
      }

      this.validation = transport.methods.validateHtmlFormat(this.definition, format, this.htmlValue)
      // 3. if text format validation past...
      if (this.validation === null) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      } else {
        // ... or launch text format error event to show error message
        this.$emit('htmlFormatError', moment().valueOf(), this.validation)
      }
    },
    isMultiLanguage () {
      return transport.methods.isMultiLanguage(this.definition)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    setObjectHtmlValue (object, fromUploadTask) {
      var metadataObj = null
      if (fromUploadTask) {
        metadataObj = this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata')
      }

      if (this.isMultiLanguage()) {
        if (object) {
          this.object.languageValue = object.languageValue

          if (metadataObj && metadataObj.languageValue) {
            for (var i = 0; i < metadataObj.languageValue.length; i++) {
              metadataObj.languageValue[i].value = ''
            }
          }
        }
        this.object = transport.methods.setLanguageValue(this.object, this.htmlValue, this.languageSelected.key)
      } else {
        this.object.textValue = this.htmlValue
      }

      this.setIframeHtml('preview')
      if (this.readOnly) {
        this.setIframeHtml(this.tinyId)
      }
    },
    setHtmlValue (languageSelected) {
      if (!this.isMultiLanguage() && this.object.textValue) {
        this.htmlValue = this.object.textValue
        this.setIframeHtml('preview')
        if (this.readOnly) {
          this.setIframeHtml(this.tinyId)
        }
      } else if (languageSelected) {
        this.setLanguageHtmlValue(languageSelected)
        this.editorContent = this.getMetadataValue()
      }
    },
    setLanguageHtmlValue (languageSelected) {
      this.htmlValue = transport.methods.getLanguageValue(this.object, languageSelected.key)
      this.setIframeHtml('preview')
      if (this.readOnly) {
        this.setIframeHtml(this.tinyId)
      }
    },
    setIframeHtml (id) {
      if (this.$refs[id]) {
        var doc = this.$refs[id].contentWindow.document
        doc.open()
        doc.write(this.htmlValue)
        if (doc.body) {
          doc.body.style.padding = '5px'
          // doc.body.style.overflow = 'hidden'
          if (!this.editable) {
            doc.body.style.zoom = '90%'
          }
          if (this.isSimpleHtml) {
            doc.body.style.fontFamily = 'sans-serif'
            doc.body.style.fontSize = '14px'
            doc.body.style.fontStyle = 'italic'
            doc.body.style.color = '#888'
          }
        }
        doc.close()
      }
    },
    refreshDefinition (object) {
      this.htmlValue = transport.methods.getLanguageValue(object, this.languageSelected.key)
      this.$emit('refreshDefinition', object)
    },
    refreshObjectHtmlValue (requestObjectForAdd) {
      var object = transport.methods.getRequestObjectById(this.definition.id, [requestObjectForAdd])
      if (this.isMultiLanguage()) {
        this.htmlValue = transport.methods.getLanguageValue(object, this.languageSelected.key, [this.definition])
      } else {
        this.htmlValue = object.textValue
      }
      this.setObjectHtmlValue(object)
    },
    getMetadataLangValue (fromLanguage) {
      var result = null
      var metadataObj = this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata')
      if (metadataObj && metadataObj.languageValue) {
        for (var i = 0; i < metadataObj.languageValue.length && !result; i++) {
          if (metadataObj.languageValue[i].key === fromLanguage.key) {
            result = metadataObj.languageValue[i].value
          }
        }
      }
      return result
    },
    copy (fromLanguage) {
      if (this.htmlValue.trim() !== '' && this.isMultiLanguage() && this.object.languageValue && this.object.languageValue.length > 1) {
        this.translating = true
        var self = this
        setTimeout(function () {
          self.copyLanguage(fromLanguage, 0, self.object.languageValue, self.getMetadataLangValue(fromLanguage))
        }, 200)
      }
    },
    copyLanguage (fromLanguage, index, languages, metadataLanguageValue) {
      if (languages && index < languages.length) {
        var language = this.object.languageValue[index]
        if (language.key !== fromLanguage.key && language.value.trim() === '') {
          transport.methods.setLanguageValue(this.object, this.htmlValue, language.key)
          transport.methods.setLanguageValue(this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata'), metadataLanguageValue, language.key)
        }
        this.copyLanguage(fromLanguage, ++index, languages, metadataLanguageValue)
      } else {
        var self = this
        setTimeout(function () {
          self.translating = false
          self.$emit('validateMandatory', moment().valueOf(), self.object)
        }, 200)
      }
    },
    isForCopy () {
      return transport.methods.isForCopy(this.definition)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    getEditorId () {
      return 'd1_' + this.tinyId + moment().valueOf()
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    getMetadataValue () {
      var result
      var name = this.definition.id + 'metadata'
      var obj = this.getRequestObjectById(this.requestObjectForAdd, name)

      if (!obj) {
        obj = this.getRequestObjectById(this.definitionObject, name)
      }

      if (obj) {
        result = transport.methods.getLanguageValue(obj, this.languageSelected.key)

        if (result === '') {
          result = {}
        } else {
          result = JSON.parse(result)
        }
      } else {
        result = {}
      }

      return result
    },
    isEmpty (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false
        }
      }
      return JSON.stringify(obj) === JSON.stringify({})
    },
    isHtmlUploaded () {
      return (this.htmlValue && this.htmlValue !== '' && (!this.editorContent || this.isEmpty(this.editorContent)))
    },
    getTemplateValue (name) {
      var result = ''

      if (this.content) {
        var namePreffix = 'apptmpl_template_'
        var definition = transport.methods.getRequestDefinitionById(namePreffix + name, this.content.requestDefinition)

        if (definition) {
          result = transport.methods.getObjectTextValue(
            null,
            definition,
            this.getRequestObjectById(null, namePreffix + name),
            null
          )
        }
      }

      return result
    },
    getTypeValue () {
      var result = ''
      if (this.definition.id.indexOf('email') > -1) {
        result = 'newsletter'
      } else if (this.definition.id.indexOf('landing') > -1) {
        result = 'webpage'
      } else {
        result = 'webpage'
      }
      return result
    },
    getLang (key) {
      return language(this.language, key)
    },
    getRequestObjectById (reqObj, id) {
      if (reqObj) {
        return transport.methods.getRequestObjectById(id, [reqObj])
      } else if (this.content) {
        return transport.methods.getRequestObjectById(id, this.content.requestObject)
      } else {
        return []
      }
    },
    getTemplateDomains () {
      var result = []

      result.push(
        {
          id: 'individual',
          title: 'addIndividualParamsTitle',
          keys: this.getTemplateDomain('individualformvars')
        }
      )
      result.push(
        {
          id: 'professional',
          title: 'addProfessionalParamsTitle',
          keys: this.getTemplateDomain('professionalformvars')
        }
      )
      result.push(
        {
          id: 'indicator',
          title: 'addIndicatorParamsTitle',
          keys: this.getTemplateDomain('individualindicatorvars')
        }
      )

      return result
    },
    getTemplateDomain (name) {
      var result = []
      if (this.content) {
        var namePreffix = 'apptmpl_template_'
        var definition = transport.methods.getRequestDefinitionById(namePreffix + name, this.content.requestDefinition)
        if (definition) {
          result = definition.validation.domain
        }
      }
      return result
    },
    definitionLoaded () {
      this.loadingEditor = false
    },
    editorChange (template, html) {
    },
    editorSave (template, html) {
      var contentObj = this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata')
      var contentHtmlObj = this.object

      // not equals languages = language change
      if (this.languageSelected && this.previousLanguageKey !== this.languageSelected.key) {
        this.savingLanguageTemplate = true
      }

      // save template before language change
      if (this.savingLanguageTemplate) {
        if (!this.previousLanguageKey && this.languageSelected) {
          this.previousLanguageKey = this.languageSelected.key
        }
        if (contentObj) {
          transport.methods.setLanguageValue(contentObj, template, this.previousLanguageKey)
        }
        if (this.isMultiLanguage()) {
          transport.methods.setLanguageValue(contentHtmlObj, html, this.previousLanguageKey)
        } else {
          this.object.textValue = html
        }

        var self = this
        setTimeout(function () {
          self.savingLanguageTemplate = false
          if (this.languageSelected) {
            this.previousLanguageKey = this.languageSelected.key
          }
        }, 200)

      // save template before copy template to other languages
      } else if (this.copyingTemplateLanguage) {
        if (contentObj) {
          transport.methods.setLanguageValue(contentObj, template, this.languageSelected.key)
        }
        if (this.isMultiLanguage()) {
          transport.methods.setLanguageValue(contentHtmlObj, html, this.languageSelected.key)
        } else {
          this.object.textValue = html
        }

        this.copyTemplate()

      // call save template service
      } else {
        if (contentObj) {
          transport.methods.setLanguageValue(contentObj, template, this.languageSelected.key)
        }
        if (this.isMultiLanguage()) {
          transport.methods.setLanguageValue(contentHtmlObj, html, this.languageSelected.key)
        } else {
          this.object.textValue = html
        }
      }

      this.editing = false
      this.editorContentBckp = null
      this.$nextTick(() => {
        this.$emit('callSaveByFieldChange')
      })
    },
    previewToEdit () {
      this.editing = true
      this.loadingEditor = true
      this.editorContentBckp = JSON.parse(JSON.stringify(this.editorContent))
    },
    saveEditor () {
      this.saveTemplate = {
        ts: moment().valueOf()
      }
    },
    cancelEditor () {
      this.editorContent = null
      this.$nextTick(() => {
        this.editorContent = JSON.parse(JSON.stringify(this.editorContentBckp))
        this.editorContentBckp = null
      })
      this.editing = false
    },
    deleteHtml () {
      // Dialog
      let message = this.getLang('confirmDeleteHtml')
      let options = {
        okText: this.getLang('delete'),
        cancelText: this.getLang('cancel'),
        customClass: 'sherpaDialog'
      }
      this.$dialog.confirm(message, options)
        .then(() => {
          var contentObj = this.getRequestObjectById(this.requestObjectForAdd, this.definition.id + 'metadata')
          var contentHtmlObj = this.object

          transport.methods.setLanguageValue(contentObj, '', this.languageSelected.key)
          transport.methods.setLanguageValue(contentHtmlObj, '', this.languageSelected.key)

          this.setIframeHtml('preview')
        })
        .catch(() => {
        })
    },
    simpleHtmlTextChange (delta, oldDelta, source) {
      this.editorSave(null, this.htmlValue)
    },
    downloadHtml2Pdf () {
      let opt = {
        margin: [10, 0, 10, 0],
        filename: `document.pdf`,
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { 
          scale: 2, 
          useCORS: true,
          letterRendering: true,
          logging: false
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      }
      // for open in new window
      html2pdf().from(this.htmlValue).set(opt).toPdf().get('pdf').then(function (pdf) {
        window.open(pdf.output('bloburl'), '_blank')
      })
    }
  },
  mounted () {
    if (!this.languageSelected) {
      if (this.definition.validation && this.definition.validation.language) {
        this.newLanguageSelected(this.definition.validation.language[0])
      } else {
        this.newLanguageSelected({key: this.getLang(), value: this.getLang(), mandatory: false})
      }
    }
    this.setHtmlValue(this.languageSelected)
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch html format validation
        this.validateHtmlFormat()
      }
    },
    languageSelected (languageSelected) {
      if (this.languageSelected) {
        this.previousLanguageKey = this.languageSelected.key
      }
      if (this.isMultiLanguage()) {
        this.setLanguageHtmlValue(languageSelected)
      }
      if (languageSelected) {
        this.editorContent = null
        this.$nextTick(() => {
          this.setHtmlValue(this.languageSelected)
        })
      }
    },
    object: {
      handler (object) {
        this.editorContent = null
        this.$nextTick(() => {
          this.setHtmlValue(this.languageSelected)
        })
      },
      deep: true
    },
    requestObjectForAddModified: {
      handler (requestObjectForAddModified) {
        this.refreshObjectHtmlValue(this.requestObjectForAdd)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.definition-wrapper.html {
  .preview {
    transition: all 0.2s ease-in;
    background-color: #fff;
    /* position: fixed; */
    top: 124px;
    right: 0px;
    left: 100px;
    bottom: 62px;
    width: initial;

    .htmlReadOnly {
      height: 740px;
    }
  }
  .languageHtml {
    float: left;
  }
  .tiny-rest {
    position: absolute;
    z-index: 10;
    left: 50px;
    top: -35px;

    .languageSelector {
      float: right;

      &.languageSelectorHtml {
        .language {
          float: right;
          min-width: 106px;
          min-height: 51px;
        }

        .multiselect {
          width: 106px;
          display: inline-block;

          .multiselect__content-wrapper {
            position: relative;
          }

          .arrow {
            left: 80px;
          }
        }
      }
    }
  }

  input.w3-input {
    border-radius: 3px;
    background-color: #ffffff;
    border: solid 1px #e8e8e8;
    height: 40px;

    &:focus {
      border: solid 1px #b8b8b8;
    }
  }
  .mce-panel {
    border-width: 0 !important;
    border: 0 !important;
  }

  .htmlReadOnly {
    border: 0;
    width: 100%;
    height: 180px;
  }

  .html2PdfButton {
    position: absolute;
    left: 8px;
    top: 8px;
    border: 0;
    outline: 0;
    background-color: rgba(255,204,0,0.8);
    cursor: pointer;
    width: 34px;
    height: 34px;
    padding-top: 4px;
    border-radius: 3px;

    &:hover {
      transition: all 0.2s ease-in;
      background-color: rgba(255,204,0,1);
    }

    i {
      color: #555;
      font-size: 21px;
      font-weight: 900;
    }
  }

  .overImage {
    position: absolute;
    background-color: rgba(0,0,0,0.45);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    .text {
      position: absolute;
      top: 50%;
      margin: -15px auto 0;
      text-align: center;
      left: 0;
      right: 0;
      transition: margin-top 0.2s ease-in-out;
      padding: 15px;
      width: 440px;
      background-color: rgba(55,55,55,0.85);

      span {
        padding: 6px 16px 7px;
        text-transform: uppercase;
        font-size: 16px;
        font-family: "Source Sans Pro", sans-serif;
        cursor: pointer;
        font-weight: 600;
        transition: all .2s ease-in;
        display: inline-block;
        min-width: 145px;
        margin: 0 10px;

        i {
          vertical-align: middle;
          margin-right: 2px;
        }

        &.edit {
          background-color: #d42e12;
          color: #fff;
        }
        &.delete {
          background-color: #d42e12;
          color: #000;
        }
        &:hover {
          &.edit {
            color: #000;
          }
          &.delete {
            color: #999;
          }
        }
      }
    }
  }

  .editing {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 100px;
    right: 0;
    background-color: #202020;
    z-index: 100000000;
    overflow: hidden;

    .editor-buttons {
      text-align: right;
      position: fixed;
      bottom: 0;
      left: 100px;
      right: 0;
      background-color: #000;
      height: 62px;

      button {
        margin-right: 18px;
        margin-top: 9px;
        padding: 0 20px;
        height: 45px;
        border-radius: 0;
        outline: none !important;
        border: 0;
        cursor: pointer;
        transition: all .2s ease-in;

        span {
          font-family: "Source Sans Pro", sans-serif;
          font-weight: 600;
          font-size: 20px;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          text-align: center;

          i {
            font-size: 16px;
            vertical-align: middle;
            margin-right: 3px;
          }
        }

        &.save {
          background-color: #d42e12;
          color: #ffffff;
        }

        &.cancel {
          background-color: #d42e12;
          color: #000;
        }

        &:hover {
          &.save {
            color: #000;
          }

          &.cancel {
            color: #999;
          }
        }
      }
    }
  }

  .gallery-fade-enter-active {
    transition: all 0.2s ease-in-out;
  }
  .gallery-fade-enter-to {
    opacity: 1;
  }
  .gallery-fade-enter {
    opacity: 0;

    .text {
      margin-top: -35px !important;
    }
  }

  .tiny-rest {
    &.remove {
      left: 190px;
      top: -25px;

      i {
        font-size: 25px;
        cursor: pointer;

        &:before {
          color: #5dbecb;
          transition: all .2s ease-in;
        }

        &:hover {
          &:before {
            color: #4599a4;
          }
        }
      }

      .loading {
        margin-top: 5px;
      }
    }
  }
}
.repeatableGroupReadOnly {
  .definition-wrapper.html {
    .overImage {
      display: none;
    }
  }
}
</style>
